import { shouldShowCampaignsNavItem } from './campaignsNavAccess'

const STORAGE_KEY_PREFIX = 'campaigns_nav_announcement_dismissed'
const AUTO_OPEN_DELAY_MS = 800

export const CAMPAIGNS_SETUP_CALL_URL = 'https://try.leaddelta.com/meetings/igor-stankovic'

type CampaignsNavAnnouncementWorkspace = Parameters<typeof shouldShowCampaignsNavItem>[0] & {
    isStarter?: boolean
    isBusiness?: boolean
}

type CampaignsNavAnnouncementSubscription = {
    isValid?: boolean
} | null | undefined

/** Paying Pro plan users (monthly or annual), excluding trial, Starter, Business, and lifetime. */
export function isProPayingUser(
    trial: boolean,
    lifetime: boolean,
    subscription: CampaignsNavAnnouncementSubscription,
    workspace: CampaignsNavAnnouncementWorkspace
): boolean {
    if (trial || lifetime) return false
    if (!subscription?.isValid) return false
    if (workspace?.isStarter || workspace?.isBusiness) return false
    return true
}

export function getCampaignsNavAnnouncementStorageKey(userId: string) {
    return `${STORAGE_KEY_PREFIX}_${userId}`
}

export function isCampaignsNavAnnouncementDismissed(userId: string | undefined): boolean {
    if (!userId) return true
    return localStorage.getItem(getCampaignsNavAnnouncementStorageKey(userId)) === 'true'
}

export function dismissCampaignsNavAnnouncement(userId: string) {
    localStorage.setItem(getCampaignsNavAnnouncementStorageKey(userId), 'true')
}

export function shouldShowCampaignsNavAnnouncement(
    userId: string | undefined,
    onboardingStep: number,
    workspace: CampaignsNavAnnouncementWorkspace
): boolean {
    if (!userId) return false
    if (onboardingStep >= 0) return false
    if (!shouldShowCampaignsNavItem(workspace)) return false
    if (isCampaignsNavAnnouncementDismissed(userId)) return false
    return true
}

export { AUTO_OPEN_DELAY_MS as CAMPAIGNS_NAV_ANNOUNCEMENT_DELAY_MS }
